import { GiCheckMark } from 'react-icons/gi'
import { GoalData } from '../../data'

import styles from './Button.module.css'
import buttonImage from './dssd.png'

interface ButtonProps {
    data: GoalData
    selected: boolean
    setSelected: (selected: boolean) => void
}

export default function Button({ data, selected, setSelected }: ButtonProps) {
    return (
        <button
            className={`${styles.buttonContainer} ${selected ? styles.selected : ''}`}
            style={{
                //backgroundImage: `url(${buttonImage})`,
                //backgroundSize: 'contain',
                //backgroundRepeat: 'no-repeat',
                position: 'absolute',
                zIndex: 1,
                left: `${data.position[0]}%`,
                top: `${data.position[1]}%`,
            }}
            onClick={() => {
                if (selected) setSelected(false)
                else setSelected(true)
            }}
        >
           <img src={data.image} alt="buttonpng" width="100%"/>
            
        </button>
    )
}
